<template>
  <!-- stavka liste "kategorija (plavo) + naslov" (Recepti i Kako pomaze na pocetnoj); stilovi liste: activity-feed iz teme -->
  <li class="feed-item">
    <NuxtLink :to="recipeLink(recipe, itemRoute)">
      <p class="text-primary mb-1 font-size-12 text-uppercase">{{ recipe.category_name }}</p>
      <p class="mt-0 mb-0 font-size-16 text-dark">{{ recipe.title }}</p>
    </NuxtLink>
  </li>
</template>

<script setup>
defineProps({
  recipe: { type: Object, required: true },
  // ruta pojedinacnog teksta (npr. 'kako-pomaze-category-title-id' za Kako pomaze)
  itemRoute: { type: String, default: 'recept-category-title-id' },
})

const recipeLink = useRecipeLink()
</script>
